import { jsx } from 'react/jsx-runtime';

/**
 * Polymorphic component for rendering rich text.
 *
 * @defaultValue `React.Fragment`
 */ const RichText = ({ as: Component = 'span', renderChildrenAsHTML = true, children, className, ...rest })=>{
    if (renderChildrenAsHTML && typeof children === 'string') {
        /**
         * Only allow strings to be rendered as HTML
         *
         * TODO: [WCDS] Replace with a more fully featured solution
         *  like Contentful's Rich Text Renderer
         */ return jsx(Component, {
            ...rest,
            className: className,
            dangerouslySetInnerHTML: {
                __html: children
            }
        });
    }
    return jsx(Component, {
        ...rest,
        className: className,
        children: children
    });
};

export { RichText };
